// `fetch_url` — the server reads the URL the MODEL declares (never one from the
// browser) and maps the answer; shown only when the read failed, with the
// step's own retry caption ("Read again").

import AutoStep from './AutoStep'
import type { StepProps } from './common'

export default function FetchUrlStep(props: StepProps) {
  const label = props.ctl.step?.retry?.button || 'Read again'
  return <AutoStep {...props} retryLabel={label} note="The reading could not be taken." />
}
